/**
 * Product analytics helpers — Ticket 16.
 *
 * Fire-and-forget trackers for browser-only product events.
 * Never throw; never block UI.
 */

import axios from '../axios-instance';
import { getAttributionIds } from './attribution';

/**
 * Admin copied a booking/share link.
 * @param {{ eventId?: number|string, eventUrl?: string }} params
 */
export function trackBookingLinkCopied({ eventId, eventUrl } = {}) {
  try {
    if (!eventId && !eventUrl) return;

    const payload = {};
    if (eventId) payload.scheduling_event_type_id = Number(eventId);
    if (eventUrl) payload.event_url = String(eventUrl);

    axios.post('analytics/track/booking-link-copied', payload).catch(() => {});
  } catch (_) {
    // fail-open
  }
}

/**
 * Public booking page viewed (after event resolved by slug).
 * Session dedupe is enforced server-side via idempotency key.
 * @param {string} slug event_url
 */
export function trackBookingPageViewed(slug) {
  try {
    if (!slug) return;

    const ids = getAttributionIds();
    axios
      .post('analytics/track/booking-page-viewed', {
        slug: String(slug),
        anonymous_id: ids.anonymous_id || undefined,
        session_id: ids.session_id || undefined,
      })
      .catch(() => {});
  } catch (_) {
    // fail-open
  }
}
